import React from 'react';
import './PathwayBlock.css';

function PathwayBlock({ title, details, workshops }) {
    return (
        <div className="pathway-block">
            <header className="pathway-block__header">
                <h4 className="pathway-block__title">{title}</h4>
                {details && <p className="pathway-block__details">{details}</p>}
            </header>
            <ul className="pathway-block__workshops-list">
                {workshops.map((workshop, index) => (
                    <li key={index}>{workshop}</li>
                ))}
            </ul>
        </div>
    );
}

export default PathwayBlock;